import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\Api\AddressApiController::countries
* @see app/Http/Controllers/Admin/Api/AddressApiController.php:28
* @route '/address/countries'
*/
export const countries = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: countries.url(options),
    method: 'get',
})

countries.definition = {
    methods: ["get","head"],
    url: '/address/countries',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Api\AddressApiController::countries
* @see app/Http/Controllers/Admin/Api/AddressApiController.php:28
* @route '/address/countries'
*/
countries.url = (options?: RouteQueryOptions) => {
    return countries.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Api\AddressApiController::countries
* @see app/Http/Controllers/Admin/Api/AddressApiController.php:28
* @route '/address/countries'
*/
countries.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: countries.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Api\AddressApiController::countries
* @see app/Http/Controllers/Admin/Api/AddressApiController.php:28
* @route '/address/countries'
*/
countries.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: countries.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Api\AddressApiController::countries
* @see app/Http/Controllers/Admin/Api/AddressApiController.php:28
* @route '/address/countries'
*/
const countriesForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: countries.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Api\AddressApiController::countries
* @see app/Http/Controllers/Admin/Api/AddressApiController.php:28
* @route '/address/countries'
*/
countriesForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: countries.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Api\AddressApiController::countries
* @see app/Http/Controllers/Admin/Api/AddressApiController.php:28
* @route '/address/countries'
*/
countriesForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: countries.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

countries.form = countriesForm

/**
* @see \App\Http\Controllers\Admin\Api\AddressApiController::states
* @see app/Http/Controllers/Admin/Api/AddressApiController.php:40
* @route '/address/states'
*/
export const states = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: states.url(options),
    method: 'get',
})

states.definition = {
    methods: ["get","head"],
    url: '/address/states',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Api\AddressApiController::states
* @see app/Http/Controllers/Admin/Api/AddressApiController.php:40
* @route '/address/states'
*/
states.url = (options?: RouteQueryOptions) => {
    return states.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Api\AddressApiController::states
* @see app/Http/Controllers/Admin/Api/AddressApiController.php:40
* @route '/address/states'
*/
states.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: states.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Api\AddressApiController::states
* @see app/Http/Controllers/Admin/Api/AddressApiController.php:40
* @route '/address/states'
*/
states.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: states.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Api\AddressApiController::states
* @see app/Http/Controllers/Admin/Api/AddressApiController.php:40
* @route '/address/states'
*/
const statesForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: states.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Api\AddressApiController::states
* @see app/Http/Controllers/Admin/Api/AddressApiController.php:40
* @route '/address/states'
*/
statesForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: states.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Api\AddressApiController::states
* @see app/Http/Controllers/Admin/Api/AddressApiController.php:40
* @route '/address/states'
*/
statesForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: states.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

states.form = statesForm

/**
* @see \App\Http\Controllers\Admin\Api\AddressApiController::cities
* @see app/Http/Controllers/Admin/Api/AddressApiController.php:61
* @route '/address/cities'
*/
export const cities = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: cities.url(options),
    method: 'get',
})

cities.definition = {
    methods: ["get","head"],
    url: '/address/cities',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Api\AddressApiController::cities
* @see app/Http/Controllers/Admin/Api/AddressApiController.php:61
* @route '/address/cities'
*/
cities.url = (options?: RouteQueryOptions) => {
    return cities.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Api\AddressApiController::cities
* @see app/Http/Controllers/Admin/Api/AddressApiController.php:61
* @route '/address/cities'
*/
cities.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: cities.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Api\AddressApiController::cities
* @see app/Http/Controllers/Admin/Api/AddressApiController.php:61
* @route '/address/cities'
*/
cities.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: cities.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Api\AddressApiController::cities
* @see app/Http/Controllers/Admin/Api/AddressApiController.php:61
* @route '/address/cities'
*/
const citiesForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: cities.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Api\AddressApiController::cities
* @see app/Http/Controllers/Admin/Api/AddressApiController.php:61
* @route '/address/cities'
*/
citiesForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: cities.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Api\AddressApiController::cities
* @see app/Http/Controllers/Admin/Api/AddressApiController.php:61
* @route '/address/cities'
*/
citiesForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: cities.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

cities.form = citiesForm

const address = {
    countries: Object.assign(countries, countries),
    states: Object.assign(states, states),
    cities: Object.assign(cities, cities),
}

export default address